//dynamic product recomendations
document.addEventListener("DOMContentLoaded", function() {
 dynamicRecommendationsFunction(null);
});
document.addEventListener("shopify:section:load", function(e) {
  var target = e.target;
  dynamicRecommendationsFunction(target);
});

function dynamicRecommendationsFunction(target){
  //var recommendedSections = document.querySelectorAll('#product_related_body,#product_complementary_body');
  var recommendedSections = document.querySelectorAll('.dynamic-recommendation-section');
  recommendedSections.forEach(function(recommendedSection){
    if(target != null){
      var targetSection = target.querySelector('.dynamic-recommendation-section');
      if(targetSection == recommendedSection){
        sliderRecommendedLoop(recommendedSection);
      }
    } else {
      sliderRecommendedLoop(recommendedSection);
    }
  });
};

function sliderRecommendedLoop(recommendedSection){
  var productRecomendationBody = recommendedSection.querySelector('.grid-container-wrapper');
      //if container
      if(productRecomendationBody != null){
        var sectionId = productRecomendationBody.dataset.sectionid;
        //var wrapper = document.querySelector('.slider-parent');
        var url = recommendedSection.dataset.url;
        //productRecomendationBody.innerHTML = '<div class="slider-container-inner"></div>';
        var sliderSelector =  productRecomendationBody;
        //ASYNC FUNCTION
        //This function returns a promise
        var getProducts = async () => {
          try {
            var recommendURL = url.trim();// remove the unwanted whitespace
            var response = await fetch(recommendURL);//this operation takes some time, so we wait
            //This will return a new promise so we can call .then on the response
            var products = await response.json();
            //we pass the retruned data from products into the function
            console.log('Products loaded', products);
            return products;

          } catch(err){
            console.log(new Error(`Unable to load products ${err.message}`));
          }
        }
        //END ASYNC FUNCTION
        //this is the data from the response
        getProducts()
        .then(({products}) => {
          //if image is equal to or greater than 1
          if(products.length > 0) {
            // Stop if the section was removed/re-rendered while async work was happening.
            if (!recommendedSection.isConnected) return;

            var loadedCount = 0;
            //for each product
            products.forEach((product, index) => {
              var product_handle = product.handle;
               var xhttp = new XMLHttpRequest();
                xhttp.onload = function() {
                  if (!recommendedSection.isConnected) return;
                  var productRow = this.response;
                  sliderSelector.insertAdjacentHTML('afterbegin', productRow);

                  loadedCount += 1;
                  if (loadedCount === products.length) {
                    recommendedSection.classList.remove('d-none');
                    scheduleRecommendedSliderInit(sectionId, sliderSelector);

                    var eventRecommendation = new CustomEvent('shopify-recommendation:init-product-grid', {
                      detail: { recommendations: products }
                    });
                    document.dispatchEvent(eventRecommendation);

                    // add image aspect ratio class
                    var imageRatio = recommendedSection.dataset.imageratio;
                    var images = productRecomendationBody.querySelectorAll('img');
                    if(images.length > 0){
                      images.forEach(function(image){
                        image.classList.add(imageRatio);
                      });
                    }
                  }
                 }
                xhttp.open("GET", '/products/' + product_handle + '?view=recommended-product');
                xhttp.send();
            });
          }
          if(products.length < 3){
            sliderSelector.classList.add('w-100');
          }
          if(products.length == 0){
            recommendedSection.classList.add('d-none');
          }
        })
        .catch((err) => {
          console.log('Rejected', err);
        });
      }
}
// recommended products slider
function sliderRecommendedProducts(sectionId,productRecomendationBody) {
  if (typeof tns !== 'function') return null;
  if (!productRecomendationBody || !productRecomendationBody.isConnected || !productRecomendationBody.parentNode) return null;
  if (productRecomendationBody.getBoundingClientRect && productRecomendationBody.getBoundingClientRect().width === 0) return null;

  window.__recommendationSliders = window.__recommendationSliders || {};

  if (window.__recommendationSliders[sectionId]) {
    try { window.__recommendationSliders[sectionId].destroy(); } catch (e) {}
    window.__recommendationSliders[sectionId] = null;
  }

  var controlsContainerSelector = '#'+sectionId+' .recommendations-slider-controls';
  var hasControlsContainer = document.querySelector(controlsContainerSelector) != null;

  var config = {
    container: productRecomendationBody,
    items: 1,
    slideBy: 1,
    nav: false,
    speed: 400,
    mode: 'carousel',
    prevButton: '#'+sectionId+' .js-slider-sites-prev',
    nextButton: '#'+sectionId+' .js-slider-sites-next',
    autoplayButtonOutput: false,
    autoplay: false,
    controls: true,
    freezable: true,
    touch: false,
    mouseDrag: false,
    preventScrollOnTouch: true,
    navPosition: 'bottom',
    rewind: true,
    lazyload: true,
    center: false,
    loop: false,
    responsive: {
      480: { items: 1 },
      640: { items: 2 },
      768: { items: 3 }
    }
  };

  if (hasControlsContainer) config.controlsContainer = controlsContainerSelector;

  var slider2 = tns(config);
  window.__recommendationSliders[sectionId] = slider2;
  slider2.refresh();
  return slider2;
}

function scheduleRecommendedSliderInit(sectionId, productRecomendationBody, opts) {
  opts = opts || {};
  var maxAttempts = opts.maxAttempts || 60;
  var attempt = 0;

  window.__recommendationSliderInitTimers = window.__recommendationSliderInitTimers || {};
  if (window.__recommendationSliderInitTimers[sectionId]) {
    clearTimeout(window.__recommendationSliderInitTimers[sectionId]);
  }

  window.__recommendationSliderInitTimers[sectionId] = setTimeout(function() {
    (function tick() {
      if (!productRecomendationBody || !productRecomendationBody.isConnected || !productRecomendationBody.parentNode) return;
      if (productRecomendationBody.getBoundingClientRect && productRecomendationBody.getBoundingClientRect().width === 0) {
        if (++attempt < maxAttempts) return requestAnimationFrame(tick);
        return;
      }

      // Only init once the DOM is stable and measurable to avoid tiny-slider crashes.
      if (!window.__recommendationSliders || !window.__recommendationSliders[sectionId]) {
        sliderRecommendedProducts(sectionId, productRecomendationBody);
      }
    })();
  }, 50);
}
